<template>
  <div class="eg" :class="'eg-' + size" v-tip="`Dodges ${ev.front}% from the front, ${ev.side}% from the sides, ${ev.back}% from behind; ${ev.magic}% of spells`">
    <span v-if="size === 'lg'" class="eg-title">Evasion</span>
    <div class="eg-cross">
      <span class="eg-c eg-f" :class="tone(ev.front)">{{ ev.front }}</span>
      <span class="eg-c eg-l" :class="tone(ev.side)">{{ ev.side }}</span>
      <span class="eg-c eg-me">▲</span>
      <span class="eg-c eg-r" :class="tone(ev.side)">{{ ev.side }}</span>
      <span class="eg-c eg-b" :class="tone(ev.back)">{{ ev.back }}</span>
      <span class="eg-c eg-m" :class="tone(ev.magic)">✦{{ ev.magic }}</span>
    </div>
    <span v-if="size === 'lg' && sources.length" class="eg-from">{{ sources.join(' · ') }}</span>
  </div>
</template>

<script>
// A unit's chance to dodge, by the side it's hit from (the cross: front on top, the sides, back below; ▲ is the unit
// facing up) and ✦ for spells. The same numbers as the current card's evade grid (lib/evasion.js via unitInfo).
export default {
  name: 'EvadeGrid',
  props: { ev: { type: Object, required: true }, sources: { type: Array, default: () => [] }, size: { type: String, default: 'sm' } },
  methods: { tone(v) { return v >= 40 ? 'hi' : v >= 20 ? 'mid' : v > 0 ? 'lo' : 'zero'; } },
};
</script>

<style scoped>
.eg { display: inline-flex; flex-direction: column; align-items: center; gap: 2px; }
.eg-title { font-family: var(--cond); font-weight: 700; font-size: 11px; letter-spacing: 1.6px; text-transform: uppercase; color: var(--brass); }
.eg-cross { display: grid; grid-template-columns: repeat(3, auto); grid-template-rows: repeat(3, auto); gap: 1px; }
.eg-c { display: grid; place-items: center; font-family: var(--cond); font-weight: 700; font-variant-numeric: tabular-nums; border-radius: 2px; color: #f3ecd8; }
.eg-sm .eg-c { min-width: 17px; height: 13px; font-size: 10.5px; }
.eg-lg .eg-c { min-width: 30px; height: 22px; font-size: 14px; }
.eg-f { grid-column: 2; grid-row: 1; } .eg-l { grid-column: 1; grid-row: 2; } .eg-me { grid-column: 2; grid-row: 2; color: var(--brass) !important; font-size: 9px !important; }
.eg-r { grid-column: 3; grid-row: 2; } .eg-b { grid-column: 2; grid-row: 3; } .eg-m { grid-column: 3; grid-row: 1; color: #c9b6ff !important; background: transparent !important; }
.eg-c.hi { background: rgba(80,170,90,.55); } .eg-c.mid { background: rgba(80,170,90,.28); } .eg-c.lo { background: rgba(255,255,255,.1); } .eg-c.zero { background: rgba(255,255,255,.04); color: #6b7488; }
.eg-from { max-width: 220px; text-align: center; font-size: 11px; color: var(--mute); }
</style>
